module.exports = __webpack_public_path__ + "static/media/search.c210f942.png";